import React from 'react';
import PropTypes from 'prop-types';

function Unlock({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18.222 11H5.778C4.796 11 4 11.814 4 12.818v6.364C4 20.186 4.796 21 5.778 21h12.444c.982 0 1.778-.814 1.778-1.818v-6.364C20 11.814 19.204 11 18.222 11zM8 11V7.446a4.7 4.7 0 011.042-2.981c.672-.818 1.595-1.332 2.592-1.442.997-.111 1.996.19 2.803.843.806.653 1.364 1.613 1.563 2.692"
      />
    </svg>
  );
}

Unlock.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Unlock;
